import { styled } from '@mui/system';
import { theme } from 'oems/theme';
import { Stack as StackMUI } from '@mui/material';

export const Container = styled('div')`
  height: 25px;
  width: 117px;
  border-radius: 6px;
  background-color: ${theme.palette.pricing.choice};
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 15px;
`;

export const ClientDescription = styled('h4')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  color: ${theme.palette.pricing.choiceForeground};
  margin: 0;
`;
